import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import { IApproverTimeOff, ITimeOff, TimeOffInput } from './interface';
import { IUserTimeOffs } from '@tsin-core/states/staff/staff';

const API_URI = `${environment.apiBaseUrl}/request-form`;
@Injectable({
    providedIn: 'root'
})
export class TimeOffService {
    http: HttpClient = inject(HttpClient);

    getTimeOffRequests(queryParams: { formTitle: string }) {
        return this.http.get<ITimeOff[]>(API_URI, { params: queryParams });
    }

    createTimeOff(input: TimeOffInput) {
        return this.http.post<ITimeOff>(`${API_URI}/create/time-off-form`, input);
    }

    getSingle(id: string) {
        return this.http.get<ITimeOff>(`${API_URI}/single/${id}`);
    }

    getTimeOffBysUser(input: { id: string; query: string }) {
        return this.http.get<ITimeOff[]>(`${API_URI}/user/${input.id}?formTitle=${input.query}`);
    }

    getTimeOffByApproverRequests(input: { id: string; query: string }) {
        return this.http.get<IApproverTimeOff[]>(
            `${API_URI}/assigned-requests/${input.id}?formTitle=${input.query}`
        );
    }
}
